import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup , Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-update-district-master',
  templateUrl: './update-district-master.component.html',
  styleUrls: ['./update-district-master.component.scss'],
})
export class UpdateDistrictMasterComponent implements OnInit {
  districtData;
  districtForm: FormGroup;
  prantData;

  constructor(
    private dialogref: MatDialogRef<UpdateDistrictMasterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private service: DigisubservicesService
  ) {
    this.districtForm = fb.group({
     districtid: [''],
  districtname: ['', Validators.required],
  prant_id: ['', Validators.required],
  sequence_id: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getAllPrantData();
    this.districtData = this.data['district'];
    // console.log(this.districtData);

    this.districtForm.get('districtid').setValue(this.districtData['id']);
    this.districtForm.get('districtname').setValue(this.districtData['name']);
    this.districtForm.get('sequence_id').setValue(this.districtData['sequence_id']);

    if (this.districtData['prant_id'] != null) {
      this.districtForm.get('prant_id').setValue(this.districtData['prant_id']);
    }
  }

  getAllPrantData() {
    this.service.getAllPrantData().subscribe((res) => {
      // console.log(res);
      this.prantData = res;
    });
  }

  // updateDistrict() {
  //   if (this.districtForm.get('districtid').value > 0) {
  //     this.service
  //       .updateDistrictName(
  //         parseInt(this.districtForm.get('districtid').value),
  //         this.districtForm.get('districtname').value,
  //         this.districtForm.get('prant_id').value,
  //         this.districtForm.get('sequence_id').value,

  //       )
  //       .subscribe((data) => {
  //         alert('District updated successfully...');
  //         this.dialogref.close({ res: 'close' });
  //       });
  //   }
  // }


  updateDistrict() {
  if (this.districtForm.get('districtid').value > 0) {
   this.service.updateDistrictName(
  parseInt(this.districtForm.get('districtid').value),
  this.districtForm.get('districtname').value,
  parseInt(this.districtForm.get('sequence_id').value),  // ← sequence_id 3rd
  parseInt(this.districtForm.get('prant_id').value),     // ← prant_id 4th
)
      .subscribe(
        (data) => {
          alert('District updated successfully...');
          this.dialogref.close({ res: 'close' });
        },
        (error) => {
          if (error.status === 409) {
            alert('This Sequence ID is already assigned!');
          }
        }
      );
  }
}
}
